import type { WizardStep, PlacementOption } from './types';
import { FRONT_PRESETS, BACK_PRESETS } from '@designdeck/shared';

/** Mount point of the wizard in the admin branch (see App.tsx). */
export const ONBOARDING_BASE_PATH = '/admin/onboarding';

/**
 * Wizard step definitions with URL paths
 */
export const STEPS: WizardStep[] = [
  {
    id: 'customer',
    path: 'customer',
    title: 'Customer Data',
    subtitle: 'Email and name for access',
  },
  {
    id: 'shop',
    path: 'shop',
    title: 'Shop Basics',
    subtitle: 'Name, language and URL',
  },
  {
    id: 'collection',
    path: 'collection',
    title: 'Collection',
    subtitle: 'Theme and product selection',
  },
  {
    id: 'design',
    path: 'design',
    title: 'Design Upload',
    subtitle: 'Upload front and/or back design',
  },
  {
    id: 'review',
    path: 'review',
    title: 'Review & Launch',
    subtitle: 'Review and create shop',
  },
];

/**
 * Get step index by path
 */
export function getStepIndexByPath(path: string): number {
  const index = STEPS.findIndex((s) => s.path === path);
  return index >= 0 ? index : 0;
}

/**
 * Get step path by index
 */
export function getStepPathByIndex(index: number): string {
  return STEPS[index]?.path ?? STEPS[0]?.path ?? '';
}

// Collections are now loaded from API - see @/api/onboarding

/**
 * Front placement options - derived from shared presets
 */
export const FRONT_PLACEMENTS: PlacementOption[] = FRONT_PRESETS.map(
  (preset) => ({
    id: preset.id,
    label: preset.name,
    description: preset.description,
    icon: preset.icon ?? '📐',
  })
);

/**
 * Back placement options - derived from shared presets
 */
export const BACK_PLACEMENTS: PlacementOption[] = BACK_PRESETS.map(
  (preset) => ({
    id: preset.id,
    label: preset.name,
    description: preset.description,
    icon: preset.icon ?? '📐',
  })
);
